import { render, staticRenderFns } from "./DmsUsersTabsItems.vue?vue&type=template&id=120daeb9"
import script from "./DmsUsersTabsItems.vue?vue&type=script&lang=js"
export * from "./DmsUsersTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports